import { StopPayment } from '../../stop-payments';
import { PendingAchPayment } from '../pending-ach.entity';
import { PendingLoan } from '../pending-loan.entity';
import { PendingTransfer } from '../pending-transfer.entity';
import { PendingUser } from '../pending-user.entity';
import { PendingWire } from '../pending-wire.entity';

export enum ApprovalTypes {
    Transfer = 'transfer',
    Loan = 'loanpayment',
    Wire = 'wire',
    ACH = 'ach',
    StopPayment = 'stoppayment',
    User = 'user',
}

export enum ApprovalDecision {
    Approve = 'approve',
    Reject = 'reject',
}

export enum ApprovalActions {
    ApproveTransfer = 'Approve Transfer',
    ApproveLoanPayment = 'Approve Loan Payment',
    ApproveWirePayment = 'Approve WIRE Payment',
    ApproveACHPayment = 'Approve ACH Payment',
}

export type PendingApproval =
    | PendingAchPayment
    | PendingWire
    | PendingLoan
    | PendingTransfer
    | StopPayment
    | PendingUser;

export type PendingPayment = PendingAchPayment | PendingWire | PendingLoan | PendingTransfer;

export interface ApprovalCounts {
    [ApprovalTypes.Transfer]: number;
    [ApprovalTypes.Loan]: number;
    [ApprovalTypes.Wire]: number;
    [ApprovalTypes.ACH]: number;
    [ApprovalTypes.StopPayment]: number;
    [ApprovalTypes.User]: number;
}
